import { useState } from 'react';
import { businessOptions, goalOptions, roleOptions } from './constants';
import { SetupSection } from './Onboarding.styles';
import { AuthFormShell } from './AuthForm.styles';
import Chips from './shared/Chips';
import IconCards from './shared/IconCards';
import Question from './shared/Question';
import Button from '../../molecules/Button';


function OnboardingStep3({ data, onNext }) {
  const [business, setBusiness] = useState(data?.business || null);
  const [role, setRole] = useState(data?.role || null);
  const [goal, setGoal] = useState(data?.goal || null);
  const ready = Boolean(business && role && goal);


  return (
    <AuthFormShell>
      <div className="auth-heading">
        <h1>
          Let&apos;s tailor your <span className="gradient-text">workspace.</span>
        </h1>
        <p>Three quick questions. Then we&apos;ll prepare your outbound machine.</p>
      </div>

      <SetupSection>
        <Question label="What best describes your business?">
          <IconCards options={businessOptions} value={business} onSelect={setBusiness} />
        </Question>
        <Question label="What best describes your role?">
          <Chips options={roleOptions} value={role} onSelect={setRole} />
        </Question>
        <Question label="What is your primary goal?">
          <Chips options={goalOptions} value={goal} onSelect={setGoal} />
        </Question>
      </SetupSection>

      <div className="btn-holder">
        <Button rounded disabled={!ready} onClick={() => onNext({ business, role, goal })} variant="onboarding-gradient">
          Continue
        </Button>
      </div>

    </AuthFormShell>
  );
}

export default OnboardingStep3;

